import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {Layout} from './utility/context/Layout';
import {store} from './redux/storeConfig/store';
import 'antd/dist/antd.css';
import './index.scss';
import {saveState, PERSISTED_KEYS} from './redux/storeConfig/localStorage';
import App from './App';

let saveTimer;
store.subscribe(() => {
	clearTimeout(saveTimer);
	saveTimer = setTimeout(() => {
		const state = store.getState();
		saveState(PERSISTED_KEYS.reduce((acc, key) => { acc[key] = state[key]; return acc; }, {}));
	}, 300);
});
ReactDOM.render(
	<Provider store={store}>
		<Layout>
			<App />
		</Layout>
	</Provider>,
	document.getElementById('root')
);
